export default {
  title: {
    id: 'services_mobile_plan_offers_drawer_title',
    defaultMessage: 'The details of the {partner} offers',
  },
  closeButtonLabel: {
    id: 'services_mobile_plan_offers_drawer_close_button_label',
    defaultMessage: 'Close the mobile plan offers details',
  },
}
